/*  MUI  */
import { Tab } from '@mui/material';

/*  Shared  */
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { Route } from 'application/Shared/Helpers';

/* Hooks */
import { useFetchTenantSetting } from 'hooks/dataAccess/Tenant/tenantSetting';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

export const UserDashboardTabs = () => {
    const { t } = useTranslation();
    const { clientId, partnerId, tab, userId } = useParams();
    const activeTab = tab ?? 'overview';

    const { setting: logAccess, loading } = useFetchTenantSetting({
        clientId,
        key: 'security_logging'
    });

    const baseAdminRoute = Route.buildBaseAdminRoute({
        clientId,
        partnerId
    });

    return (
        !loading && (
            <MUITabsWrapper value={activeTab}>
                <Tab
                    component={Link}
                    to={`${baseAdminRoute}/user/${userId}/overview`}
                    value="overview"
                    label={
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'flex'
                            }}
                        >
                            {t('User.overview')}
                        </span>
                    }
                    aria-label="User Overview"
                    data-trackid="admin_userOverview_overview"
                />
                <Tab
                    component={Link}
                    to={`${baseAdminRoute}/user/${userId}/admin`}
                    value="admin"
                    label={
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'flex'
                            }}
                        >
                            {t('User.admin')}
                        </span>
                    }
                    aria-label="Admin"
                    data-trackid="admin_userOverview_admin"
                />
                {logAccess && !loading && (
                    <Tab
                        component={Link}
                        to={`${baseAdminRoute}/user/${userId}/logs`}
                        value="logs"
                        label={
                            <span
                                style={{
                                    alignItems: 'center',
                                    display: 'flex'
                                }}
                            >
                                {t('Common.security_logs')}
                            </span>
                        }
                        aria-label="Logs"
                        data-trackid="admin_userOverview_securityLogs"
                    />
                )}
            </MUITabsWrapper>
        )
    );
};
